import { Card, CardBody, Container, Row } from "reactstrap";
import { useEffect, useState } from "react";

import AuditTrailContent from "./auditTrailContent";
import DeleteUser from "./../deleteUser";
import Loading from "./../../loader/loader";
import NkHeader from "./../../../common/nkheader";
import NkTable from "./../../users/nktable";
import ReAssignRole from "./../reAssignRole";
import React from "react";
import { role } from "../manageuserVerification/utils";

const AuditTrailheader = ({
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  setModalShow,
  setReassignshow,
  handleFIlter,
  filterValues,
  auditTrailList,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  auditTrailListExcel,
  columns,
  columnsCsv,
  pagination,
  resetFilter,
  setFilterForm,
  excelLoading,
  setSizeShow,
  modalShow,
  reassignshow,
  handleChange,
  options,
  selectedOption,
  statusFilter,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
}) => {
  return (
    <>
      <Container fluid>
        <NkHeader title="Audit Trail" />
        <AuditTrailContent
          resetFilter={resetFilter}
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          handleFIlter={handleFIlter}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />

        <>
          <Row>
            <div
              className="col"
              style={{ paddingLeft: "1px", paddingRight: "1px" }}
            >
              <Card style={{ padding: "1.25rem 1.5rem" }}>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      dataexcal
                      filename={"audittrail"}
                      data={auditTrailList}
                      buttonRef={buttonRef}
                      type="audittrail"
                      filterdata={filterForm}
                      onExcelClciked={() => onExcelClciked(filterForm)}
                      dataEXCEL={auditTrailListExcel}
                      columns={columns}
                      columnsCsv={columnsCsv}
                      excelLoading={excelLoading}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      </Container>
      <DeleteUser
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
      />
      {/* 
      <ReAssignRole
        show={reassignshow}
        onHide={() => setReassignshow(false)}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
      /> */}
    </>
  );
};

export default AuditTrailheader;
